import { Component } from 'react';
import PropTypes from 'prop-types';

export default class BundleLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mod: null,
    };
  }

  componentDidMount() {
    this.load(this.props);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { load } = this.props;
    if (nextProps.load !== load) {
      this.load(nextProps);
    }
  }

  load(props) {
    this.setState({
      mod: null,
    });
    props.load().then((mod) => {
      this.setState({
        // handle both es imports and cjs
        mod: mod.default ? mod.default : mod,
      }, props.moduleLoaded);
    });
  }

  render() {
    const { children } = this.props;
    const { mod } = this.state;
    return children(mod);
  }
}

BundleLoader.propTypes = {
  load: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  moduleLoaded: PropTypes.func, // eslint-disable-line
};

BundleLoader.defaultProps = {
  moduleLoaded: null,
};
